import styled from "styled-components";

export const LabelValuePairsLayout = styled.div<{ gap?: string }>`
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-column-gap: ${({ gap }) => gap || "2rem"};
    grid-row-gap: 0.5rem;
`;
